import React from 'react';
import { Resource, activateResource } from '../../lib/resources';
import { UserCheck, UserX, Trash2 } from 'lucide-react';

interface QuickActionsProps {
  resource: Resource;
  onDeactivate: () => void;
  onActivate: () => void;
  onDelete: () => void;
  deactivateLoading: boolean;
  activateLoading: boolean;
  deleteLoading?: boolean;
}

export default function QuickActions({
  resource,
  onDeactivate,
  onActivate,
  onDelete,
  deactivateLoading,
  activateLoading,
  deleteLoading = false
}: QuickActionsProps) {
  return (
    <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
      <div className="px-4 py-3 border-b border-gray-200 bg-gray-50">
        <h3 className="text-sm font-medium text-gray-900">Quick Actions</h3>
      </div>
      <div className="p-2">
        {resource.status === 'inactive' ? (
          <>
            <button
              onClick={onActivate}
              disabled={activateLoading}
              className="w-full text-left px-4 py-2 text-sm rounded-md text-green-600 hover:bg-green-50 flex items-center"
            >
              <UserCheck className="h-4 w-4 mr-2" />
              {activateLoading ? 'Activating...' : 'Activate Employee'}
            </button>
            <button
              onClick={onDelete}
              disabled={deleteLoading}
              className="w-full text-left px-4 py-2 mt-2 text-sm rounded-md text-red-600 hover:bg-red-50 flex items-center"
            >
              <Trash2 className="h-4 w-4 mr-2" />
              {deleteLoading ? 'Deleting...' : 'Delete Employee'}
            </button>
          </>
        ) : (
        <button
          onClick={onDeactivate}
          disabled={deactivateLoading || resource.status === 'inactive'}
          className="w-full text-left px-4 py-2 text-sm rounded-md text-red-600 hover:bg-red-50 flex items-center"
        >
          <UserX className="h-4 w-4 mr-2" />
          {deactivateLoading ? 'Deactivating...' : 'Deactivate Employee'}
        </button>
        )}
      </div>
    </div>
  );
}